import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import type { OperationsHeaderProps } from './types';
import { HeaderSection, Title, PrimaryButton } from './styles';

const OperationsHeader: React.FC<OperationsHeaderProps> = ({ onGlossaryClick }) => (
  <HeaderSection>
    <Title level={3}>Operations</Title>
    <PrimaryButton
      type="primary"
      icon={<FontAwesomeIcon icon={faCircleQuestion} />}
      onClick={onGlossaryClick}
      aria-label="Open Operations glossary"
    >
      Operations glossary
    </PrimaryButton>
  </HeaderSection>
);

export default React.memo(OperationsHeader);
